import React from "react";

function TremsAndCondition() {
  return (
   <div className="container">
  <h2>Terms and Conditions</h2>
  <p>
    Welcome to <strong>psf.academy</strong> – a digital finance platform that offers services such as personal loans, EMI-based purchases, and other financial assistance.
  </p>
  <p>
    By accessing or using this website, you agree to be bound by the following terms and conditions. If you do not agree with any part of these terms, please do not use our services.
  </p>
  <p>
   PSF ACADEMY provides financial services in collaboration with licensed NBFCs and banking partners. All loan offers, approvals, and disbursals are subject to eligibility checks and regulatory compliance.
  </p>
  <p>
    Users must provide accurate, complete, and up-to-date information during registration, loan application, and KYC processes. Providing false or misleading information may lead to suspension of services or legal action.
  </p>
  <p>
    PSF ACADEMY reserves the right to update, modify, or revise these terms and conditions at any time without prior notice. Continued use of the website after changes implies acceptance of the updated terms.
  </p>
  <p>
    All disputes are subject to the jurisdiction of the courts located in <strong>Jaipur, Rajasthan, India</strong>, and governed by Indian laws including the IT Act and RBI Guidelines.
  </p>
  <p>
    For queries or clarifications regarding these terms, contact us at <a href="tel:+919214433316">+919214433316</a> or Email: info@psf.academy.
  </p>
</div>

  );
}

export default TremsAndCondition;
